module.exports = __webpack_public_path__ + "img/bryan-kelly-sm-2x.ecadb2e.webp";